<app-automatic-debit
  *ngIf="automaticDebit"
  (setAutoDebitAccount)="autoDebitAccountSelected = $event"
  (setAutoDebitAccountImage)="autoDebitAccountSelectedImage = $event"
  (changeAutomaticDebit)="automaticDebit = $event"
  [visbleCancel]="true"
/>

<div class="main">
  <p class="title-approbe-validate">Validación y firma de documentos</p>
  <div class="contenedor-documentos">
    <div class="contenedor-amount">
      <p class="contenedor-documentos-title">Cupo pre-aprobado</p>
      <p class="amount">
        {{ amountFinance | currency : "USD" : "symbol" : "1.0-0" }}
      </p>
    </div>
    <div class="documents-style">
      <p
        *ngFor="let document of documents; let i = index"
        (click)="abrirDocumento(modalDocumento, document)"
      >
        {{ i + 1
        }}{{
          document.name === "_Pagare"
            ? document.name
                .split("_")
                .join(" ")
                .replace("e", "é")
                .replace("on", "ón")
            : document.name.split("_").join(" ").replace("cion", "ción")
        }}
      </p>
      <label
        for="automaticDebitCheck"
        class="automaticDebitCheck"
        id="automaticDebitCheck"
      >
        <input
          type="checkbox"
          id="automaticDebitCheck"
          [checked]="!automaticDebit && autoDebitAccountSelected"
          (click)="handleAutomaticDebit()"
        />
        <p *ngIf="!autoDebitAccountSelected">
          <b>
            Autorizo que paymentsway realice la automatización del débito
            automático de mi cuenta
          </b>
          para el pago de las cuotas del crédito.
        </p>
        <div
          *ngIf="autoDebitAccountSelected"
          class="automaticDebitCheckSelected"
          id="automaticDebitCheckSelected"
        >
          <h1>Débito automático activado</h1>
          <div
            class="automaticDebitCheckSelectedContent"
            id="automaticDebitCheckSelectedContent"
          >
            <div
              class="automaticDebitCheckSelectedContentTitle"
              id="automaticDebitCheckSelectedContentTitle"
            >
              <img [src]="autoDebitAccountSelectedImage" alt="" />
              <h1>{{ autoDebitAccountSelected.bankName }}</h1>
            </div>
            <h2>
              Número de Cuenta:
              {{ maskText(autoDebitAccountSelected.accountNumber) }}
            </h2>
          </div>
          <button
            class="autoDebitAccountSelectedButton"
            id="autoDebitAccountSelectedButton"
            (click)="handleModifyAutomaticDebit()"
          >
            Modificar
          </button>
        </div>
      </label>
    </div>
  </div>

  <div class="container-insurance">
    <label class="form-check-label" for="flexCheckDefault">
      Este crédito incluye un seguro de vida deudor
    </label>
    <p class="details" (click)="openTermConditions(2)">Ver detalles</p>
  </div>

  <div class="form-check">
    <div class="check-style">
      <input
        [(ngModel)]="showFormOtp"
        class="form-check-input checkbox-tyc"
        type="checkbox"
      />
      <label class="form-check-label" for="flexCheckDefault">
        He leído y acepto los documentos</label
      >
    </div>
    <label class="label-term" (click)="openTermConditions(1)" for=""
      ><fa-icon [icon]="circleInfo"></fa-icon> Términos y Condiciones</label
    >
  </div>
  <div *ngIf="showFormOtp && autoDebitAccountSelected">
    <p class="title-approbe mt-3">
      Firma los documentos con el código que enviamos a tu celular
    </p>
    <app-form
      *ngIf="showFormOtp && autoDebitAccountSelected"
      [controls]="controls$ | async"
      (sendInfo)="getConfirmOtp($event)"
    ></app-form>
    <p class="otp mt-3" (click)="enviarNuevoOtp()">Recibir otro código</p>
  </div>

  <!-- <div *ngIf="mostrarError" class="contenedor-alerta-codigo-erroneo">
    <div class="contenedor-textos">
      <fa-icon [icon]="circleInfo"></fa-icon>
      <p>El código ingresado es incorrecto, verifica e intenta de nuevo</p>
    </div>
    <a (click)="enviarNuevoOtp()" class="enviar-codigo">Enviar otro codigo</a>
  </div> -->

  <div *ngIf="mostrarNuevoCodigo" class="contenedor-alerta-nuevo-codigo">
    <fa-icon [icon]="checkCircle"></fa-icon>
    <p>Un nuevo código ha sido enviado por mensaje de texto a tu celular</p>
  </div>
</div>

<ng-template #modalDocumento>
  <app-pdf-content></app-pdf-content>
</ng-template>

<!-- <div class="check-style druo" *ngIf="dataDruo == null && checkDruo">
  <input [(ngModel)]="showDialog" (click)="openDialogDruo()" class="form-check-input checkbox-tyc check-mobile"
    type="checkbox">
  <label class="form-check-label" for="flexCheckDefault">
    <b>Autorizo a que <img src="../../../../../assets/img/logo-druo.png" alt="Logo Druo">
      debite de mi cuenta bancaria</b> para el pago de las cuotas del crédito.</label>
</div>

<div class="check-style druo druo-active" *ngIf="dataDruo != null">
  <label class="form-check-label" for="flexCheckDefault"><b> Débito automático activado </b></label>
  <span><img [src]="dataDruo.imgBank" alt="Logo Banco" width="24" height="auto" style="margin-right: 0.5rem;"> {{
    dataDruo.nameBank }}</span>
  <label *ngIf="dataDruo.numShort">Cuenta: {{ dataDruo.numShort }}</label>
  <label *ngIf="!dataDruo.numShort">{{ dataDruo.numero.length > 4 ? '***' + dataDruo.numero.slice(-4) :
    dataDruo.numero }}</label>
  <p class="update-bank" (click)="openDialogDruo()">Modificar</p>
</div> -->
